export default __webpack_public_path__ + "static/Expertise-1513bef29d6dcb80bc33c86254680fbb.webp";